import React from "react";

interface ProjectBannerProps {
  name: string;
  type: string;
  address: string;
  company: string;
  lenderLabel: string;
  lenderName: string;
}

const ProjectBanner = ({
  name,
  type,
  address,
  company,
  lenderLabel,
  lenderName,
}: ProjectBannerProps) => (
  <div className="projBanner">
    <div className="projBanner__left">
      <h1>{name}</h1>
      <p>
        {type} · {address} · {company}
      </p>
    </div>
    <div className="projBanner__right">
      <div className="projBanner__lenderLabel">{lenderLabel}</div>
      <div className="projBanner__lenderName">{lenderName}</div>
    </div>
  </div>
);

export default ProjectBanner;
